import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';
import { AnimationTransparentView } from '../AnimationTransparentView/AnimationTransparentView';
import { ClaimBingoAnimation } from '../ClaimBingoAnimation/ClaimBingoAnimation';
import { ClaimDiceAnimation } from '../ClaimDiceAnimation/ClaimDiceAnimation';
import { ClaimHammerAnimation } from '../ClaimHammerAnimation/ClaimHammerAnimation';
import { ClaimPlinkoAnimation } from '../ClaimPlinkoAnimation/ClaimPlinkoAnimation';
import { ClaimPuzzleAnimation } from '../ClaimPuzzleAnimation/ClaimPuzzleAnimation';
import { ClaimRouletteAnimation } from '../ClaimRouletteAnimation/ClaimRouletteAnimation';
import { MissionXpGiftCelebration } from '../Missions/components/MissionXpGiftCelebration';

import { GC_COIN_LANDING_OFFSET } from './constants';
import { FlyingCoinsAnimation } from './FlyingCoinsAnimation';

import './FlyingCoins.css';

export const FlyingCoinsAnimationComponent = observer(() => {
  const { uiStore, coinTypeStore } = useStores();
  const isGC = coinTypeStore.coinType === 'GC';

  const { gcLandingPoint, scLandingPoint } = uiStore.coinsLandingPos;

  const onEndHandler = () => {
    if (typeof uiStore.onEndCallback === 'function') {
      uiStore?.onEndCallback();
    }
    uiStore.stopCoinsAnimation();
  };

  return (
    <>
      {uiStore.CoinsAnimationVisible && (
        <FlyingCoinsAnimation
          fadeInDurationMs={uiStore.animationProps?.fadeInDurationMs}
          Gc={{
            amount: uiStore.CoinsAnimationGCAmount,
            landingSpotCords: gcLandingPoint,
            landingOffsetX: 0,
            landingOffsetY: isGC ? GC_COIN_LANDING_OFFSET : 0,
          }}
          isGCEnd={uiStore?.onGCCoinLandCallback}
          isSCEnd={uiStore?.onSCCoinLandCallback}
          Sc={{
            amount: uiStore.CoinsAnimationSCAmount,
            landingSpotCords: scLandingPoint,
            landingOffsetX: 0,
            landingOffsetY: isGC ? 0 : GC_COIN_LANDING_OFFSET,
          }}
          transitionDurationMs={uiStore.animationProps?.transitionDurationMs}
          onEnd={onEndHandler}
        />
      )}
      <ClaimPuzzleAnimation />
      <ClaimDiceAnimation />
      <ClaimHammerAnimation />
      <AnimationTransparentView />
      <ClaimPlinkoAnimation />
      <ClaimBingoAnimation />
      <ClaimRouletteAnimation />
      <MissionXpGiftCelebration />
    </>
  );
});
